const hasSearchById = (state) => (searchId) => {
  const foundSearch = state.searchesCache.find((search) => search.id === searchId);
  return foundSearch !== undefined;
};

// eslint-disable-next-line
const getSearchById = (state) => (searchId) => {
  return state.searchesCache.find((search) => search.id === searchId);
};

export default {
  hasSearchById,
  getSearchById,
};
